<template>
    <v-container> 
        <v-card class="mt-4" height="90px" style="border-radius: 8px;">
            <v-layout>
                <v-flex xs2>
                    <v-avatar
                    size="60"
                    >   
                    <v-img
                            class="elevation-6 ml-5 mt-1"
                            src="https://firebasestorage.googleapis.com/v0/b/nicechats-prod.appspot.com/o/Google%20Sheets%20(1).png?alt=media&token=e3f4228c-1334-4480-9e9f-d1dce438a026"
                        ></v-img>
                    </v-avatar>
                </v-flex>
                <v-flex xs5>
                    <div class="headline mt-3">Google sheets Integration</div>
                </v-flex>
                <v-flex xs2>
                    <v-btn v-if="googleSheets.status == 'noAccess' || googleSheets.status == 'revoked'" flat round class="mt-3" color="primary" @click="generateUrl">Grant Access</v-btn>
                    <v-btn v-if="googleSheets.status == 'granted'" flat disabled round class="mt-3" color="primary" @click="generateUrl">Access Granted</v-btn>
                </v-flex>
                <v-flex xs2>                    
                    <v-btn v-if="googleSheets.status == 'granted'" flat round class="mt-3" color="primary" @click="revokeAceess">Revoke Access</v-btn>
                    <v-btn v-if="googleSheets.status == 'noAccess' || googleSheets.status == 'revoked'" flat disabled round class="mt-3" color="primary" @click="revokeAceess">No Access</v-btn>
                </v-flex>
            </v-layout>
        </v-card>
        <v-card class="mt-4" height="90px" style="border-radius: 8px;">
            <v-layout>
                <v-flex xs2>
                    <v-avatar
                    size="60"
                    >   
                    <v-img
                            class="elevation-6 ml-5 mt-1"
                            src="https://firebasestorage.googleapis.com/v0/b/nicechats-prod.appspot.com/o/SendGrid-Logomark.png?alt=media&token=ef633fe9-46ab-40b7-bcb0-9968fbf55f4c"
                        ></v-img>
                    </v-avatar>
                </v-flex>
                <v-flex xs5>
                    <div class="headline mt-3">SendGrid Email Integration</div>
                </v-flex>
                <v-flex xs2>
                    <v-btn v-if="sendGrid.status == 'noAccess' || sendGrid.status == 'revoked'" flat round class="mt-3" color="primary" @click="connectSendgrid($event,'sendgrid')">Connect</v-btn>
                    <v-btn v-if="sendGrid.status == 'granted'" flat disabled round class="mt-3" color="primary" @click="connectSendgrid($event,'sendgrid')">Connected</v-btn>
                </v-flex>
                <v-flex xs2>                    
                    <v-btn v-if="sendGrid.status == 'granted'" flat round class="mt-3" color="primary" @click="disconnectSendgrid">Disconnect</v-btn>
                    <v-btn v-if="sendGrid.status == 'noAccess' || sendGrid.status == 'revoked'" flat disabled round class="mt-3" color="primary" @click="disconnectSendgrid">Disconnected</v-btn>
                </v-flex>
            </v-layout>
        </v-card>
                <v-menu v-model="integrationMenu"
                :close-on-click = "false"
                :position-x="x"
                :position-y="y"
                offset-x
                :close-on-content-click="false"
                :nudge-width="600">
            <v-card>
                <sendgrid1  v-if="cardtype == 'sendgrid'"></sendgrid1>
            </v-card>
        </v-menu> 
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '../store'
import sendgrid1 from './Integration-sendgrid.vue'
export default {
    components:{
        sendgrid1
    },
    data(){
        return{
            x:0,
            y:0,
            cardtype:null
            }       
    },
    methods:{
        generateUrl(){ 
            let url 
            let pageid = this.$route.params.page_id
            console.log(pageid)
            let res1 = axios({
                    method: "get",
                    url: "https://small-umbra.glitch.me/generateGURL",
                    data: null,
                    params: {pageid}
                })
            .then(response => {
                url = response.data.gurl
                window.open(url, "_parent");
            })
            .catch(error => {
            console.log(error)
            })
        },
        revokeAceess(){
            let pageid = this.$route.params.page_id
            let res1 = axios({
            method: "get",
            url: "https://small-umbra.glitch.me/revoke",
            data: null,
            params: {pageid}
                })
            .then(response => {
                console.log(response.data)
                store.dispatch('afetchIntegrationDetails', pageid)
            })
            .catch(error => {
            console.log(error)
            })
        },
        connectSendgrid(event,type){
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            this.cardtype = type
            let status = true
            this.$store.dispatch('aresponsemenuStatusChange',status)
        },
        disconnectSendgrid(){
            let pageid = this.$route.params.page_id  
            this.$store.dispatch('adisconnectSendgrid',pageid)
            this.$store.dispatch('afetchIntegrationDetails', pageid)
        }

    },
    created(){

    },
    computed:{
        googleSheets(){
            return this.$store.state.google_sheets
        },
        sendGrid(){
            return this.$store.state.send_grid
        },
        integrationMenu(){
            console.log(this.$store.state.responseMenuStatus)
            return this.$store.state.responseMenuStatus
        }
    }    
}
</script>
